export const IsDevelopment = window.location.href.indexOf('localhost') > -1;

export const { REACT_APP_API, REACT_APP_CDN, REACT_APP_SRIPE_KEY, REACT_APP_GOOGLE_ANALYTICS } =
  process.env;
